export default __webpack_public_path__ + "static/panbox-607e8410c0692b09b5cfd1d0f825ee75.png";